// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#alpineiq-logo{height:50px;width:200px}`, "",{"version":3,"sources":["webpack://./src/views/styles/Setup.css"],"names":[],"mappings":"AAAA,eACI,WAAA,CACA,WAAA","sourcesContent":["#alpineiq-logo {\n    height: 50px;\n    width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
